const fr = {
    '/': {
        title: '{brand} & Paris Sportifs | Retraits Instantanés',
        description: '{brand} et paris sportifs sur un seul portefeuille. Machines à sous, casino en direct et retraits crypto instantanés.',
        keywords: 'casino crypto, casino bitcoin, paris sportifs crypto, machines à sous crypto, retrait instantané, casino provably fair'
    },
    '/casino': {
        title: '{brand} Casino en Ligne | Slots, Live & Retrait Instantané',
        description: 'Machines à sous, blackjack, roulette et tables avec croupiers en direct sur {brand}. Dépôts crypto rapides et retraits instantanés 24/7.',
        keywords: 'casino crypto, jeux de casino bitcoin, casino en ligne, machines à sous crypto, casino en direct, blackjack, roulette'
    },
    '/sports': {
        title: '{brand} Paris Sportifs en Ligne | Crypto Paris & Cotes',
        description: 'Pariez sur le sport chez {brand}. Cotes compétitives sur le football, le basketball & plus. Paris en direct, mises crypto sécurisées & paiements rapides.',
        keywords: 'paris sportifs crypto, bookmaker bitcoin, paris en direct, cotes football, paris esports'
    },
    '/livecasino': {
        title: '{brand} Casino Live | Croupiers Réels, Blackjack & Roulette',
        description: 'Blackjack, roulette, baccarat et jeux TV en direct sur {brand}. De vrais croupiers, du streaming HD et des tables ouvertes 24h/24 en crypto.',
        keywords: 'casino en direct, croupiers en direct, blackjack en direct, roulette en direct, baccarat, jeux télévisés'
    },
    '/slots': {
        title: '{brand} Machines à Sous | Démos Gratuites, RTP & Max Win',
        description: 'Des milliers de machines à sous sur {brand} : Pragmatic Play, Hacksaw Gaming, Nolimit City. Essayez en démo gratuite ou jouez en crypto.',
        keywords: 'machines à sous crypto, slots bitcoin, machines à sous en ligne, video slots, megaways, achat de bonus'
    },
    '/vip': {
        title: '{brand} Programme VIP | Récompenses Exclusives & Avantages',
        description: 'Le programme VIP de {brand} : récompenses exclusives, bonus personnalisés et assistance prioritaire. Avantages pour les joueurs fidèles.',
        keywords: 'programme vip casino, rakeback, récompenses de fidélité, casino high roller, niveaux vip'
    },
    '/welcome-offer': {
        title: '{brand} Offre de Bienvenue | Casino Crypto',
        description: "Découvrez l'offre de bienvenue de {brand}. Commencez avec de la crypto et profitez d'avantages exclusifs pour les nouveaux joueurs.",
        keywords: 'bonus de bienvenue casino, bonus casino crypto, bonus premier dépôt, offre nouveaux joueurs'
    },
    '/referral': {
        title: '{brand} Programme de Parrainage | Gagnez des Récompenses',
        description: "Invitez vos amis sur {brand} et gagnez des récompenses lorsqu'ils s'inscrivent et remplissent les conditions.",
        keywords: 'programme de parrainage casino, bonus parrainage, récompenses affiliés'
    },
    '/promotion-page': {
        title: '{brand} Bonus Casino | Codes Promo & Courses Hebdo',
        description: 'Toutes les promotions actives de {brand} au même endroit : offre de bienvenue, courses hebdomadaires et tournois. Consultez les conditions.',
        keywords: 'promotions casino, bonus casino crypto, course hebdomadaire, tournois casino'
    },
    '/hotslots': {
        title: '{brand} Slots Populaires | Machines à Sous les Plus Jouées',
        description: 'Jouez aux machines à sous les plus populaires sur {brand}. Les meilleurs slots disponibles avec de la crypto.'
    },
    '/newgames': {
        title: '{brand} Nouveaux Jeux | Dernières Sorties Casino',
        description: 'Les dernières sorties casino sur {brand}, ajoutées dès leur lancement par les studios. Soyez parmi les premiers à y jouer en crypto.'
    },
    '/populargames': {
        title: '{brand} Jeux Populaires | Les Plus Joués du Moment',
        description: 'Les jeux les plus joués du moment sur {brand} : slots, tables en direct et jeux TV réunis dans une seule liste, tous jouables en crypto.'
    },
    '/gameshows': {
        title: '{brand} Jeux TV | Crazy Time, Mega Wheel & Animateurs Live',
        description: 'Jouez à Crazy Time, Mega Wheel, Monopoly Live et plus sur {brand}. Présentateurs en direct, manches en temps réel et gros multiplicateurs.'
    },
    '/table_games': {
        title: '{brand} Jeux de Table | Blackjack, Roulette & Baccarat',
        description: "Jouez au blackjack, à la roulette, au baccarat et d'autres jeux de table sur {brand}. Tout disponible avec de la crypto."
    },
    '/hotlive': {
        title: '{brand} Casino en Direct | Les Jeux Live les Plus Joués',
        description: 'Les jeux de casino en direct les plus populaires sur {brand}. Jouez avec de vrais croupiers en temps réel.'
    },
    '/featurebuyin': {
        title: '{brand} Slots Achat Bonus | Accès Direct au Tour Bonus',
        description: 'Achetez directement le tour bonus sur {brand}. Slots avec achat de bonus signées Pragmatic Play, Hacksaw Gaming, Nolimit City et plus.'
    },
    '/originals': {
        title: '{brand} Originals | Crash, Plinko & Jeux Provably Fair',
        description: "Jouez aux Originals de {brand} : Crash, Plinko, Keno, Dragon's Tower et plus. Des jeux maison provably fair aux résultats vérifiables."
    },
    '/providers': {
        title: '{brand} Fournisseurs de Jeux | Studios Partenaires & Logiciels',
        description: 'Explorez tous les fournisseurs de jeux sur {brand}. Nous collaborons avec les meilleurs studios pour vous offrir une bibliothèque crypto diversifiée et de haute qualité.'
    },
    '/about-us': {
        title: 'À Propos de Nous | En savoir plus sur {brand}',
        description: 'Découvrez {brand}, un casino crypto & sportsbook de premier plan. Engagé pour un jeu sécurisé, équitable & palpitant avec des retraits crypto instantanés.'
    },
    '/affiliate': {
        title: "Programme d'Affiliation | Gagnez de la Crypto avec {brand}",
        description: 'Devenez partenaire de {brand} & gagnez des commissions en promouvant notre casino crypto. Taux compétitifs, suivi en temps réel & support dédié aux affiliés.'
    },
    '/faq': {
        title: '{brand} FAQ | Questions Fréquemment Posées',
        description: "Trouvez des réponses aux questions courantes sur {brand}. Consultez notre FAQ pour obtenir de l'aide sur les comptes, paiements, bonus & jeux de casino."
    },
    '/aml-policy': {
        title: 'Politique LCB | Lutte Contre le Blanchiment chez {brand}',
        description: 'La politique LCB de {brand} garantit un environnement sécurisé et fiable. Découvrez nos mesures pour prévenir toute activité illicite sur notre plateforme.'
    },
    '/bonus-terms': {
        title: 'Conditions des Bonus | Promotions {brand}',
        description: 'Lisez les règles des bonus & promotions de {brand}. Apprenez comment réclamer, utiliser & retirer vos gains bonus sur notre plateforme.'
    },
    '/complaints-and-arbitration': {
        title: 'Réclamations et Arbitrage | Support Joueurs chez {brand}',
        description: 'Découvrez le processus de réclamation & résolution des litiges de {brand}. Nous garantissons un traitement équitable et résolvons les problèmes rapidement et en toute transparence.'
    },
    '/fairness': {
        title: "Jeux Provably Fair | Garantie d'Équité chez {brand}",
        description: '{brand} utilise la technologie provably fair pour garantir que chaque résultat de jeu est vérifiable, transparent & totalement aléatoire.'
    },
    '/kyc-policy': {
        title: "Politique KYC | Vérification d'Identité chez {brand}",
        description: "La politique KYC de {brand} décrit notre processus de vérification d'identité. Découvrez comment nous protégeons les joueurs et maintenons un environnement de jeu sécurisé."
    },
    '/payment-policy': {
        title: '{brand} Politique de Paiement | Dépôts & Retraits Crypto',
        description: '{brand} accepte les dépôts & retraits en crypto. Lisez notre politique de paiement pour connaître les limites de transaction, les crypto acceptées & les délais de traitement.'
    },
    '/privacy-policy': {
        title: 'Politique de Confidentialité | Vos Données chez {brand}',
        description: 'La politique de confidentialité de {brand}. Découvrez comment nous collectons, utilisons & protégeons vos données personnelles sur notre plateforme de casino crypto.'
    },
    '/responsible-gaming': {
        title: 'Jeu Responsable | Jouez en Toute Sécurité chez {brand}',
        description: '{brand} est engagé pour le jeu responsable. Accédez à des outils & ressources pour gérer vos habitudes de jeu et jouer en toute sécurité.'
    },
    '/terms-of-service': {
        title: "Conditions Générales d'Utilisation | {brand}",
        description: 'Consultez les conditions générales régissant votre utilisation de {brand}. Comprenez vos droits et responsabilités en tant que joueur.'
    },
    '/terms-sports': {
        title: 'Conditions des Paris Sportifs | {brand}',
        description: 'Les conditions des paris sportifs de {brand}. Règles pour placer des mises, encaisser les gains & utiliser le sportsbook sur notre plateforme.'
    },
    '/special-bets': {
        title: '{brand} Paris spéciaux | Bookmaker crypto',
        description: 'Placez des paris spéciaux sur {brand}. Marchés sportifs, esport & événements ponctuels, avec dépôts crypto instantanés et paiements rapides.'
    },
    '/transparency': {
        title: '{brand} Transparence | Casino crypto à équité prouvable',
        description: 'Découvrez comment {brand} fonctionne à découvert. Vérification d’équité prouvable, taux de retour publiés depuis le catalogue en direct & paiements on-chain.'
    },
    '/faq/about': {
        title: 'À propos de {brand} | FAQ',
        description: 'À propos de {brand} : licence, fonctionnement du casino crypto & ce qui rend la plateforme équitable. Réponses aux questions courantes.'
    },
    '/faq/account': {
        title: '{brand} Compte | FAQ',
        description: 'Gérer votre compte {brand} : inscription, connexion, vérification & paramètres de profil. Réponses aux questions courantes sur le compte.'
    },
    '/faq/bonuses': {
        title: '{brand} Bonus | FAQ',
        description: 'Les bonus {brand} expliqués : offres de bienvenue, codes promo, conditions de mise & récompenses. Réponses aux questions courantes.'
    },
    '/faq/deposits': {
        title: '{brand} Dépôts | FAQ',
        description: 'Comment déposer des cryptos sur {brand} : monnaies acceptées, réseaux, minimums & délais de confirmation. Réponses aux questions courantes.'
    },
    '/faq/games-sports': {
        title: '{brand} Jeux & sports | FAQ',
        description: 'Jeux de casino & paris sportifs sur {brand} : fournisseurs, équité prouvable, cotes & paris en direct. Réponses aux questions courantes.'
    },
    '/faq/responsible-gambling': {
        title: '{brand} Jeu responsable | FAQ',
        description: 'Le jeu responsable sur {brand} : limites de dépôt, auto-exclusion, périodes de pause & outils d’aide pour jouer en toute sécurité.'
    },
    '/faq/security': {
        title: '{brand} Sécurité | FAQ',
        description: 'Sécurité sur {brand} : protection du compte, authentification à deux facteurs, équité & confidentialité des données. Réponses aux questions courantes.'
    },
    '/faq/support-disputes': {
        title: '{brand} Support & litiges | FAQ',
        description: 'Obtenir de l’aide sur {brand} : chat en direct, délais de réponse & résolution des litiges. Réponses aux questions courantes.'
    },
    '/faq/withdrawals': {
        title: '{brand} Retraits | FAQ',
        description: 'Comment retirer des cryptos de {brand} : délais de paiement, minimums, frais & limites. Réponses aux questions courantes sur les retraits.'
    }
};
export default fr;
